import React from 'react'

import { BaseAddDirectDebitMethodButton } from './BaseAddDirectDebitMethodButton'

export const AddDirectDebitACH: React.FC = () => {
  return <BaseAddDirectDebitMethodButton i18nKey='addDirectDebitACH' />
}
